import classNames from 'classnames';
import styles from './ToggleButton.module.scss';
import React, {useState} from "react";

function ToggleButton(props: any) {
  const { labelId, className, isChecked, onChange, disabled } = props;

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(!isChecked)
  }

  return (
    <div className={classNames(styles.toggleButton, className)}>
      <button
        type="button"
        className={classNames(styles.toggleButtonInner, (disabled ? '!bg-[#E2E8F0]' : ''))}
        role="switch"
        aria-checked={isChecked}
        aria-labelledby={labelId}
        onClick={onClick}
        disabled={disabled}
      >
        <span className={styles.toggleButtonIndicator} />
      </button>
    </div>
  );
}

export default ToggleButton;
